import styled from 'styled-components';
import { Row, Card, Button } from 'antd';

export const Container = styled.div`
  padding: 24px;
  min-height: calc(100vh - 200px);
  text-align: center;
`;

export const Title = styled.h1<{ scheme?: string }>`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${(props) => {
    return props.scheme === 'darkUITheme' ? '#fff' : '#000';
  }};
`;

export const Description = styled.p<{ scheme?: string }>`
  font-size: 16px;
  margin-bottom: 24px;
  color: ${(props) => {
    return props.scheme === 'darkUITheme' ? '#fff' : '#666';
  }};
`;

export const StyledRow = styled(Row)`
  margin-top: 2rem;
  justify-content: center;
`;

export const StyledCard = styled(Card)`
  text-align: center;
  height: 200px;
  cursor: pointer;
`;

export const ConfigCard = styled(Card)`
  margin-bottom: 24px;
  background: #f0f8ff;
`;

export const ModulesSection = styled.div`
  margin-bottom: 24px;
`;

export const ModuleCard = styled(Card)<{ selected?: boolean }>`
  height: 100%;
  border: ${(props) =>
    props.selected ? '2px solid #1890ff' : '1px solid #d9d9d9'};
`;

export const ModuleContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const ModuleDetails = styled.div`
  flex: 1;
`;

export const ModuleTitle = styled.h4`
  margin: 0 0 8px 0;
`;

export const ModuleCategory = styled.p`
  font-size: 12px;
  color: #666;
  margin: 0 0 8px 0;
`;

export const ModuleDescription = styled.p`
  margin: 0;
  font-size: 14px;
`;

export const ActionButtons = styled.div`
  text-align: center;
  margin: 32px 0;
`;

export const SaveButton = styled(Button)`
  margin-right: 16px;
`;

export const ProceedButton = styled(Button)`
  background: #52c41a;
  border-color: #52c41a;

  &:hover {
    background: #73d13d;
    border-color: #73d13d;
  }
`;

export const SectionTitle = styled.h3`
  margin-bottom: 16px;
`;
